const DocIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <g clip-path="url(#clip0_12024_132203)">
        <path
          d="M9.33268 2.42578V5.17948C9.33268 5.55284 9.33268 5.73953 9.40534 5.88213C9.46926 6.00758 9.57125 6.10956 9.69669 6.17348C9.8393 6.24614 10.026 6.24614 10.3993 6.24614H13.153M10.666 9.57943H5.33268M10.666 12.2461H5.33268M6.66602 6.91276H5.33268M9.33268 2.24609H5.86602C4.74591 2.24609 4.18586 2.24609 3.75803 2.46408C3.38171 2.65583 3.07575 2.96179 2.884 3.33811C2.66602 3.76594 2.66602 4.32599 2.66602 5.44609V12.3794C2.66602 13.4995 2.66602 14.0596 2.884 14.4874C3.07575 14.8637 3.38171 15.1697 3.75803 15.3614C4.18586 15.5794 4.74591 15.5794 5.86602 15.5794H10.1327C11.2528 15.5794 11.8128 15.5794 12.2407 15.3614C12.617 15.1697 12.9229 14.8637 13.1147 14.4874C13.3327 14.0596 13.3327 13.4995 13.3327 12.3794V6.24609L9.33268 2.24609Z"
          stroke="#2E2E2E"
          stroke-width="1.11111"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_12024_132203">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.912109)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DocIcon;
